import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicyPage() {
  useEffect(() => {
    document.title = "プライバシーポリシー | ACOE 採用サイト";
  }, []);

  return (
    <div className="min-h-screen bg-acoe-bg">
      {/* Header */}
      <section className="pt-32 md:pt-40 pb-12 md:pb-16 bg-acoe-charcoal">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
          <Link
            to="/recruit"
            className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-8 transition-colors"
          >
            <ArrowLeft size={16} />
            採用トップに戻る
          </Link>
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.15]">
            プライバシーポリシー
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-[800px] mx-auto px-6 md:px-12">
          <div className="prose prose-stone max-w-none">
            
            <p className="text-acoe-muted mb-8">
              株式会社セイライグループジャパン（以下「当社」といいます）は、当社が運営する採用サイト（以下「本サイト」といいます）において、
              応募者の皆様（以下「ユーザー」といいます）からお預かりする個人情報の取扱いについて、以下のとおりプライバシーポリシーを定めます。
            </p>

            <div className="space-y-10">
              {/* Section 1 */}
              <div>
                <h2 className="font-heading font-bold text-xl text-acoe-charcoal mb-4">
                  1. 収集する個人情報
                </h2>
                <p className="text-acoe-muted leading-relaxed">
                  当社は、本サイトにおいて以下の個人情報を収集することがあります。
                </p>
                <ul className="list-disc list-inside text-acoe-muted mt-4 space-y-2">
                  <li>氏名</li>
                  <li>メールアドレス</li>
                  <li>電話番号</li>
                  <li>現在の所属会社名</li>
                  <li>お問い合わせ内容</li>
                  <li>その他、応募フォームにおいてユーザーが任意で入力した情報</li>
                </ul>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="font-heading font-bold text-xl text-acoe-charcoal mb-4">
                  2. 個人情報の利用目的
                </h2>
                <p className="text-acoe-muted leading-relaxed">
                  当社は、収集した個人情報を以下の目的で利用します。
                </p>
                <ul className="list-disc list-inside text-acoe-muted mt-4 space-y-2">
                  <li>採用選考の実施および連絡</li>
                  <li>カジュアル面談の日程調整および実施</li>
                  <li>採用に関するお問い合わせへの回答</li>
                  <li>採用活動に関する情報提供（ご希望された場合）</li>
                  <li>当社サービスの改善および新サービスの開発</li>
                </ul>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="font-heading font-bold text-xl text-acoe-charcoal mb-4">
                  3. 個人情報の第三者提供
                </h2>
                <p className="text-acoe-muted leading-relaxed">
                  当社は、以下の場合を除き、ユーザーの同意なく個人情報を第三者に提供することはありません。
                </p>
                <ul className="list-disc list-inside text-acoe-muted mt-4 space-y-2">
                  <li>法令に基づく場合</li>
                  <li>人の生命、身体または財産の保護のために必要がある場合</li>
                  <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
                  <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="font-heading font-bold text-xl text-acoe-charcoal mb-4">
                  4. 個人情報の管理
                </h2>
                <p className="text-acoe-muted leading-relaxed">
                  当社は、個人情報の漏洩、滅失、毀損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。
                  また、個人情報を取り扱う従業員に対して、適切な監督を行います。
                </p>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="font-heading font-bold text-xl text-acoe-charcoal mb-4">
                  5. 個人情報の保存期間
                </h2>
                <p className="text-acoe-muted leading-relaxed">
                  当社は、採用選考が終了した応募者の個人情報について、選考終了後1年間保存した後、適切に削除または廃棄します。
                  ただし、採用が決定した方の情報については、雇用管理のために必要な期間保存します。
                </p>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="font-heading font-bold text-xl text-acoe-charcoal mb-4">
                  6. 個人情報の開示・訂正・削除
                </h2>
                <p className="text-acoe-muted leading-relaxed">
                  ユーザーは、当社が保有する自己の個人情報について、開示、訂正、削除を請求することができます。
                  請求を希望される場合は、下記のお問い合わせ先までご連絡ください。
                  本人確認の上、合理的な範囲で対応いたします。
                </p>
              </div>

              {/* Section 7 */}
              <div>
                <h2 className="font-heading font-bold text-xl text-acoe-charcoal mb-4">
                  7. Cookieの使用について
                </h2>
                <p className="text-acoe-muted leading-relaxed">
                  本サイトでは、ユーザーの利便性向上およびアクセス解析のためにCookieを使用することがあります。
                  Cookieの使用を希望されない場合は、ブラウザの設定により無効化することができます。
                  ただし、Cookieを無効化した場合、本サイトの一部機能が正常に動作しない可能性があります。
                </p>
              </div>

              {/* Section 8 */}
              <div>
                <h2 className="font-heading font-bold text-xl text-acoe-charcoal mb-4">
                  8. プライバシーポリシーの変更
                </h2>
                <p className="text-acoe-muted leading-relaxed">
                  当社は、必要に応じて本プライバシーポリシーを変更することがあります。
                  変更した場合は、本サイト上で公表します。
                </p>
              </div>

              {/* Section 9 */}
              <div>
                <h2 className="font-heading font-bold text-xl text-acoe-charcoal mb-4">
                  9. お問い合わせ先
                </h2>
                <p className="text-acoe-muted leading-relaxed mb-4">
                  本プライバシーポリシーに関するお問い合わせは、下記までご連絡ください。
                </p>
                <div className="bg-acoe-stone/30 p-6 rounded-lg">
                  <p className="text-acoe-charcoal font-medium">株式会社セイライグループジャパン</p>
                  <p className="text-acoe-muted mt-2">〒102-0071 東京都千代田区富士見2-10-2</p>
                  <p className="text-acoe-muted">飯田橋グラン・ブルーム 9F</p>
                  <p className="text-acoe-muted mt-2">
                    メール：<a href="mailto:office@seiraigroup.com" className="text-acoe-charcoal underline">office@seiraigroup.com</a>
                  </p>
                </div>
              </div>
            </div>

            {/* Effective Date */}
            <div className="mt-12 pt-8 border-t border-acoe-border">
              <p className="text-sm text-acoe-muted">
                制定日：2024年1月1日<br />
                最終更新日：2025年1月1日
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
